export { AiSearchInput } from './components/ai-search-input'
export { queryAiSearch } from './services/query-ai-search'
export type { AiSearchInputRef } from './components/ai-search-input/ai-search-input'
export {
  DEFAULT_SEARCH_PLACEHOLDERS,
  DEFAULT_VEHICLE_COUNT,
  getDefaultSearchPlaceholders,
} from './constants/default-search-placeholders'
export { AI_SEARCH_MAX_QUERY_LENGTH } from './constants/search-input'
